import * as Yup from 'yup';

export const createValidationByKeys = (keys, validation) => {
  const element = keys.shift();
  if (element !== undefined) {
    return createValidationByKeys(keys, Yup.object({ [element]: validation }));
  }
  return validation;
};
